export default {
    remove: 'Poista',
    save: 'Tallenna',
    cancel: 'Peruuta',
    loading: 'Ladataan…',
    value: 'Arvo',
    'action-bar.collapse': 'Pienennä',
    'action-bar.expand': 'Laajenna',
    'action-bar.actions': 'Toiminnot',
    'callout.note': 'Huomio',
    'callout.important': 'Tärkeää',
    'callout.tip': 'Vinkki',
    'callout.caution': 'Varoitus',
    'callout.warning': 'Varoitus',
    'collapsible-section.open': 'Avaa { header } osio',
    'collapsible-section.close': 'Sulje { header } osio',
    'date-picker.today': 'Tänään',
    'date-picker.month.heading': 'Kuukausi',
    'date-picker.quarter.heading': 'Vuosineljännes',
    'date-picker.year.heading': 'Vuosi',
    'chip-set.clear-all': 'Tyhjennä kaikki',
    'snackbar.dismiss': 'Sulje',
    'file.drag-and-drop-tips':
        'Vedä & pudota tiedostosi tähän, tai napsauta selataksesi.',
    'file-viewer.message.unsupported-filetype':
        'Esikatselua ei voi näyttää tälle tiedostotyypille.',
    'file-viewer.message.try-other-options':
        'Lataa tiedosto tai avaa se uudessa välilehdessä.',
    'file-viewer.download': 'Ladata',
    'file-viewer.exit-fullscreen': 'Poistu koko näytöstä',
    'file-viewer.open-in-fullscreen': 'Avaa koko näytössä',
    'file-viewer.open-in-new-tab': 'Avaa uudella välilehdellä',
    'file-viewer.more-actions': 'Lisää…',
    'editor-menu.bold': 'Lihavoitu',
    'editor-menu.italic': 'Kursivoitu',
    'editor-menu.strikethrough': 'Yliviivaus',
    'editor-menu.h1': 'Otsikkotaso 1',
    'editor-menu.h2': 'Otsikkotaso 2',
    'editor-menu.h3': 'Otsikkotaso 3',
    'editor-menu.bulleted-list': 'Luettelomerkitty lista',
    'editor-menu.numbered-list': 'Numeroitu lista',
    'editor-menu.blockquote': 'Lohkoteksti',
    'editor-menu.link': 'Lisää linkki',
    'editor-link-menu.text': 'Teksti',
    'editor-link-menu.link': 'Linkki',
    'editor-menu.code-block': 'Koodilohko',
    'editor-menu.code': 'Koodi',
    'editor-image-view.loading': 'Ladataan kuvaa: { filename }...',
    'editor-image-view.failed': 'Jokin meni pieleen kuvan kanssa: { filename }',
    'editor-image-view.success': 'Kuva: { filename } on valmis',
    'editor-image-view.resize-handle':
        'Vedä oikealle tai vasemmalle muuttaaksesi kuvan kokoa',
    'progress-bar': 'Edistymispalkki',
    'ai-avatar.label': 'Tekoälyavatar',
    'ai-avatar.thinking': 'ajattelee',
    'table.select-all': 'Valitse kaikki rivit',
    'table.select-row': 'Valitse tämä rivi',
    'profile-picture.remove': 'Poista valittu kuva',
    'profile-picture.unsupported-preview.title': 'Tiedostomuoto ei ole tuettu',
    'profile-picture.unsupported-preview.description':
        'Emme voi näyttää valittua kuvaa tässä selaimessa. Valitse jokin toinen kuvatiedosto.',
};
